
import { useEffect, useState, useRef } from "react";
import "./TopHomepageAd.css";

const ads = [
  {
    id: 1,
    title: "Redbox Invest Summit",
    poweredBy: "Powered by Redbox Global",
    subtitle: "March 3–4, 2026 | New York",
    tagline: "Where intelligence meets capital and global markets converge",
    gradient:
      "linear-gradient(135deg, #0a0a1a 0%, #1a1a4e 35%, #6b0f1a 70%, #a01020 100%)",
    slides: [
      "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=900&q=80",
      "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=900&q=80",
      "https://images.unsplash.com/photo-1444653614773-995cb1ef9efa?w=900&q=80"
    ]
  },
  {
    id: 2,
    title: "Global Energy Forum",
    poweredBy: "Powered by Redbox Global",
    subtitle: "June 12–14, 2026 | Doha, Qatar",
    tagline: "Hear from leaders shaping the future of global energy",
    gradient:
      "linear-gradient(135deg, #1a0a3c 0%, #3d1f6e 35%, #8b5a0a 70%, #c8860a 100%)",
    slides: [
      "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=900&q=80",
      "https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=900&q=80",
      "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&h=450&fit=crop&q=80"
    ]
  },
  {
    id: 3,
    title: "Future Finance Expo",
    poweredBy: "Powered by Redbox Global",
    subtitle: "September 8–10, 2026 | Singapore",
    tagline: "Shaping the next era of global finance and investment",
    gradient:
      "linear-gradient(135deg, #0a1a2e 0%, #0d3b6e 40%, #0a6e4f 75%, #0d8c5e 100%)",
    slides: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=900&q=80",
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=900&q=80",
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=900&q=80",
      "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=1200&h=600&fit=crop&q=80"
    ]
  },
  {
    id: 4,
    title: "Global Tech & AI Forum",
    subtitle: "November 15–17, 2026 | London",
    tagline: "Innovation. Intelligence. Impact.",
    image:
      "https://images.unsplash.com/photo-1492724441997-5dc865305da7"
  }

];

function SliderAd({ ad }) {

  const [active, setActive] = useState(0);
  const timer = useRef(null);

   const goTo = (index) => {
    setActive(index);
  };

  useEffect(() => {
    timer.current = setInterval(() => {
      setActive((prev) => (prev + 1) % ad.slides.length);
    }, 3500);

    return () => clearInterval(timer.current);
  }, [ad]);



  return (
    <div className="rbx-ad-wrapper">

      <div className="rbx-ad-left" style={{ background: ad.gradient }}>
        <p className="rbx-powered">{ad.poweredBy}</p>
        <h2 className="rbx-title">{ad.title}</h2>
        <p className="rbx-date">{ad.subtitle}</p>
        <p className="rbx-tagline">{ad.tagline}</p>
        <a href="/learn-more" className="rbx-btn">Learn more</a>
      </div>

      <div className="rbx-ad-right">
        {ad.slides.map((img, i) => (
          <img
            key={i}
            src={img}
            className={`rbx-slide ${i === active ? "active" : ""}`}
            alt=""
          />
        ))}

         {/* SLIDER DOTS */}
        <div className="rbx-dots">
          {ad.slides.map((_, i) => (
            <button
              key={i}
              className={`rbx-dot ${i === active ? "rbx-dot-active" : ""}`}
              onClick={() => goTo(i)}
            />
          ))}
        </div>

         
      </div>

    </div>
  );
}

/* ---------------- Image Ad ---------------- */

function ImageAd({ ad }) {

  return (
    <div
      className="rbx-image-ad"
      style={{
        backgroundImage: `url(${ad.image})`,
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}
    >

      <div className="rbx-image-overlay">

        <h2>{ad.title}</h2>
        <p>{ad.subtitle}</p>
        <p>{ad.tagline}</p>

        <a href="/learn-more" className="rbx-btn">
          Learn more
        </a>

      </div>

    </div>
  );
}

export default function TopHomepageAd() {

  const [adReady, setAdReady] = useState(false);
  const [currentAd, setCurrentAd] = useState(null);

  const wrapperRef = useRef(null);

  useEffect(() => {

    const randomAd = ads[Math.floor(Math.random() * ads.length)];
    setCurrentAd(randomAd);

    // simulate decoupled async loading
    const timer = setTimeout(() => {
      setAdReady(true);
    }, 400);

    return () => clearTimeout(timer);

  }, []);

 

  return (

    <div className="rbx-fullwidth-wrapper">

      <div className="rbx-base-ad" ref={wrapperRef}>

        {!adReady && (
          <div className="rbx-placeholder">
            Advertisement
          </div>
        )}

        {adReady && currentAd && (

    <div className="rbx-decoupled-slot">

      {currentAd.slides ? (
        <SliderAd ad={currentAd} />
      ) : (
      <ImageAd ad={currentAd} />
      )}

  </div>

)}
      </div>

    </div>

  );
}